var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScromTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.065,
    height: 37.874,
    viewBox: "0 0 36.065 37.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scrm_ic_1",
    transform: "translate(-10.958 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M43.516,76.373h-.748a.462.462,0,0,0,0,.924h.748a.462.462,0,1,0,0-.924Z",
    transform: "translate(-16.869 -36.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M46.561,9H18.3a.462.462,0,0,0-.462.462V16.75H14.632a.462.462,0,0,0-.462.462v4.939h-.524a2.691,2.691,0,0,0-2.688,2.688V40.663a2.691,2.691,0,0,0,2.688,2.688H22.07v2.6H20.827a.462.462,0,1,0,0,.924H30.969a.462.462,0,0,0,0-.924H29.726v-2.6h8.423a2.691,2.691,0,0,0,2.688-2.688V34.977h2.194a4,4,0,0,0,3.992-3.992V9.462A.462.462,0,0,0,46.561,9ZM15.094,22.613V17.673h2.749V34.515a.462.462,0,0,0,.462.462H37.922V37.81H15.094Zm-3.213,2.226a1.767,1.767,0,0,1,1.765-1.765h.524V37.81H11.881V24.839ZM28.8,45.95H22.994v-2.6H28.8Zm11.111-5.287a1.766,1.766,0,0,1-1.765,1.764h-24.5a1.766,1.766,0,0,1-1.765-1.764V38.734H39.914v1.929Zm0-2.853H38.846V34.977h1.068ZM46.1,30.985a3.071,3.071,0,0,1-3.068,3.068H18.767v-19H46.1V30.985Zm0-16.856H18.767V9.924H46.1v4.205Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M31.789,15.476h.231a.462.462,0,0,0,0-.924h-.231a.462.462,0,0,0,0,.924Z",
    transform: "translate(-10.961 -2.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M35.48,15.476h.491a.462.462,0,0,0,0-.924H35.48a.462.462,0,1,0,0,.924Z",
    transform: "translate(-12.948 -2.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M39.735,15.476h.231a.462.462,0,0,0,0-.924h-.231a.462.462,0,1,0,0,.924Z",
    transform: "translate(-15.238 -2.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M49.836,37.932A5.934,5.934,0,1,0,43.9,32,5.941,5.941,0,0,0,49.836,37.932Zm0-10.944A5.01,5.01,0,1,1,44.826,32,5.016,5.016,0,0,1,49.836,26.988Z",
    transform: "translate(-17.728 -9.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M50.347,38.356a.462.462,0,0,0,.293.2.474.474,0,0,0,.092.009.462.462,0,0,0,.255-.077l4.965-3.293a.462.462,0,1,0-.511-.77l-4.579,3.037-1.015-1.538a.462.462,0,1,0-.771.509Z",
    transform: "translate(-20.472 -13.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M57.674,57.283h-.462a.462.462,0,0,0,0,.924h.462a.462.462,0,0,0,0-.924Z",
    transform: "translate(-24.642 -25.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M53.674,57.283h-.462a.462.462,0,0,0,0,.924h.462a.462.462,0,0,0,0-.924Z",
    transform: "translate(-22.49 -25.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M49.674,57.283h-.462a.462.462,0,0,0,0,.924h.462a.462.462,0,0,0,0-.924Z",
    transform: "translate(-20.337 -25.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M61.674,57.283h-.462a.462.462,0,0,0,0,.924h.462a.462.462,0,0,0,0-.924Z",
    transform: "translate(-26.795 -25.982)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScromTypeIcon);
export default __webpack_public_path__ + "static/media/scromTypeIcon.322ce4d2af0dc8d3389b731754e65c59.svg";
export { ForwardRef as ReactComponent };